<template>
  <div class="row my-5">
    <div class="col-12 col-md-6 mb-3" v-for="stat in statsList" :key="stat.label">
      <Stat-card :label="stat.label" :value="stat.value" />
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from 'vue';
import axios from 'axios';

import StatCard from "@/components/views/stastistics/StatCard.vue";

const stats = ref({
  links: 0,
  visitedLinks: 0,
});
const loading = ref(false);
const error = ref(null);

const apiUrl = process.env.VUE_APP_API_URL;

async function fetchStatistics(token) {

  //todo falta las apis para obtener los datos de los usuarios, links y links visitados

  const id = sessionStorage.getItem('id');


  /**
   * An object representing HTTP headers for a request.
   *
   * @constant {Object} headers
   * @property {string} Authorization - The authentication token to be sent with the request.
   *                                    The format is "Bearer {token}", where {token} is a variable
   *                                    containing the actual token value.
   */
  const headers = {'Authorization': `Bearer ${token}`};

  /**
   * Represents the response object containing data related to links.
   *
   * This variable is commonly used to store information about links returned
   * from an API or a function call. It may include properties such as status,
   * URL, metadata, or any other relevant information about the links.
   */
  const [linksRes, visitedLinksRes] = await Promise.all([
    axios.get(`${apiUrl}/count/id_user/${id}/links`, {headers}),
    axios.get(`${apiUrl}/count/id_user/${id}/linksVisited`, {headers}),
  ]);

  return {
    links: linksRes.data.count,
    visitedLinks: visitedLinksRes.data.count,
  };
}

onMounted(/**
 * Asynchronous function to fetch and update statistics while managing the loading state.
 *
 * Retrieves an authentication token from the session storage and uses it to fetch statistics.
 * Handles possible errors during the fetch process and updates the error state if necessary.
 * Ensures the loading state is properly managed during the entire operation.
 *
 * @async
 * @function
 * @throws Will set the error state if the fetch process fails.
 */
async () => {
  loading.value = true;
  const token = sessionStorage.getItem('token');
  try {
    stats.value = await fetchStatistics(token);
  } catch (e) {
    error.value = e.message;
  } finally {
    loading.value = false;
  }
});

/**
 * A computed property that provides a list of statistical data for links.
 *
 * Each element in the list is an object containing:
 * - `label`: A descriptive string for the statistic.
 * - `value`: The corresponding value of the statistic retrieved from the `stats` object.
 *
 * This list includes:
 * - Total short links.
 * - Visited links.
 *
 * @type {ComputedRef<Array<{label: string, value: number}>>}
 */
const statsList = computed(() => [
  {label: 'Total short links', value: stats.value.links},
  {label: 'Visited links ', value: stats.value.visitedLinks},
]);
</script>

<style scoped>
.card-title {
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
